import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { css } from '@emotion/react';
import t from 'react-translate';
import NvRadioButton from 'shared/components/inputs/nv-radio-button';
import NvIcon from 'shared/components/nv-icon';
import NvModal, { BackdropType, ModalType } from 'shared/components/nv-modal';
import { standardSpacing } from 'styles/global_defaults/scaffolding';

const styles = css`
  width: 800px;
  padding-top: 20vh;
  .buttons {
    & > *:not(:last-of-type) {
      margin-right: ${standardSpacing}px;
    }
  }
`;

const MultiSessionWarningModal = (props: {
  onCancel: () => void,
  onUpdate: (option: any) => void,
}) => {
  const [registerOption, setRegisterOption] = useState(null);

  return (
    <NvModal
      show
      doubleModal
      onClose={props.onCancel}
      fullHeight
      backdropType={BackdropType.DARK}
      type={ModalType.NO_DIALOG}
      body={(
        <div
          css={styles}
          className='d-flex flex-column justify-content-center align-items-center text-white mx-auto'
        >
          <NvIcon icon='warning' size='large' />
          <div className='page-title text-center my-6'>
            {t.LECTURE_PAGES.COMPONENTS.LIVE_VIDEO_EVENTS.REGISTRATION.MULTISESSION_WARNING.TITLE()}
          </div>
          <div className='text-white text-large-regular text-center'>
            {t.LECTURE_PAGES.COMPONENTS.LIVE_VIDEO_EVENTS.REGISTRATION.MULTISESSION_WARNING.DESCRIPTION()}
            <NvRadioButton
              labelClassName='text-large-regular text-white'
              value='register_everyone'
              name='registerOption'
              onChange={() => setRegisterOption('register_everyone')}
              label={t.LECTURE_PAGES.COMPONENTS.LIVE_VIDEO_EVENTS.REGISTRATION.MULTISESSION_WARNING.KEEP_ORIGINAL()}
              className='mt-6'
            />
            <NvRadioButton
              labelClassName='text-large-regular text-white'
              value='unregister_everyone'
              name='registerOption'
              onChange={() => setRegisterOption('unregister_everyone')}
              label={t.LECTURE_PAGES.COMPONENTS.LIVE_VIDEO_EVENTS.REGISTRATION.MULTISESSION_WARNING.UNREGISTER()}
              className='mt-4'
            />
          </div>
          <div className='buttons mt-6'>
            <Button
              variant='secondary'
              className='bs4-night'
              onClick={props.onCancel}
            >
              {t.FORM.CANCEL()}
            </Button>

            <Button
              variant='primary'
              className='bs4-night'
              onClick={() => props.onUpdate(registerOption)}
              disabled={!registerOption}
            >
              {t.FORM.UPDATE()}
            </Button>
          </div>
        </div>
      )}
    />
  );
};

export default MultiSessionWarningModal;
